var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgQuoteLeft = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 35c2.07 0 3.75-1.68 3.75-3.75v-10c0-2.07-1.68-3.75-3.75-3.75H30v-5c0-2.758 2.242-5 5-5h.625A1.87 1.87 0 0 0 37.5 5.625v-3.75A1.87 1.87 0 0 0 35.625 0H35c-6.906 0-12.5 5.594-12.5 12.5v18.75c0 2.07 1.68 3.75 3.75 3.75h10zm-22.5 0c2.07 0 3.75-1.68 3.75-3.75v-10c0-2.07-1.68-3.75-3.75-3.75H7.5v-5c0-2.758 2.242-5 5-5h.625A1.87 1.87 0 0 0 15 5.625v-3.75A1.87 1.87 0 0 0 13.125 0H12.5C5.594 0 0 5.594 0 12.5v18.75C0 33.32 1.68 35 3.75 35h10z",
    fill: "#3E704B"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuoteLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quote-left.f83845fe.svg";
export { ForwardRef as ReactComponent };